//Medidas banner 800x457px
export const convocatorias = [
   {
    
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Seminario de dirección escénica.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/32.-Seminario de dirección escénica.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
   {
    
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Seminario en Muralismo Colectivo en Cerámica Escultórica.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/31.-Seminario en Muralismo Colectivo en Cerámica Escultórica.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
  {
    
    "titulo": "del 10 de agost al 27 de agosto del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Oferta academica.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/30.-Oferta Academica Agosto-Diciembre 2026.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
  {

    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Narrativa Ixmiquilpan .jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/29.-taller  narrativa audiovisual  comunitaria Ixmiquilpan.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
     {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Narrativa Tlahuelilpan.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/28.-taller  narrativa audiovisual  comunitaria tlahuelilpan .pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
   {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Narrativa Real del Monte .jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/27.-taller  narrativa audiovisual  comunitaria real del monte .pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
   {
    "titulo": "CREDITOS",
    "imagen" : "../assets/imgs/Convocatorias/2026/AIEC.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/créditos AIEC 2026.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
   {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Diplomado Educación Musical.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/26.-Diplomado en  Educación Musical.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
  {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Diplomado dramaturgia.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/25.-DIPLOMADO EN DRAMATURGIA;  tejido textual del drama-trama.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
   {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Narrativa audiovisual.jpg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/24.-taller  narrativa audiovisual  comunitaria.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
  {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Danza clasica.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/22.-convocatoria Valle del Mezquital danza clásica.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
    {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Danza Clasica1.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/23.-Emiliano Zapata CONVOCATORIA Curso Enseñanza  de la Danza Clasica.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
    },
   {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Diplomado Voz.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/21.- DIPLOMADO PARA PROFESIONALES DE LA VOZ.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
   {
    "titulo": "del 10 de julio al 30 de noviembre del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Convocatoria Ayudas sociales-2026.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/18.-Convocatoria Ayudas sociales-2026.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
     },
    {
    "titulo": "del 15 de junio al 30 de noviembre del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Programa de Apoyos.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/13.-Convocatoria Fortalecimiento Actividades Artísticas y Culturales 2026.pdf",
    "estado": "CONVOCATORIA ABIERTA",
    "año": 2026
    },
   {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Curso de danza.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/20.-Curso de Especialización en  Danza Contemporánea.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
   {
    "titulo": "Sujeto a disponibilidad de cupo",
    "imagen" : "../assets/imgs/Convocatorias/2026/metodologia.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/19.-Seminario de la Metodología.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": "Resultados admitidos Alumnos",
    "imagen" : "../assets/imgs/Convocatorias/2026/R Alumnos.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados alumnos Musicampus 2026.pdf",
    "estado": "",
    "año": 2026
     },
    {
    "titulo": "Resultados admitidos Talleristas",
    "imagen" : "../assets/imgs/Convocatorias/2026/R Talleristas.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados talleistas Musicampus 2026.pdf",
    "estado": "",
    "año": 2026
      },
     {
    "titulo": "del 09 de julio al 15 de julio del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Convocatoria Orquesta.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/17.-CONVOCATORIA CONTRALORÍA SOCIAL MUSICAMPUS.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": "del 07 de julio al 17 de julio del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Curso de la danza.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/16.-Curso magistral- Enseñanza de la danza clásica en infancias y adolescencias.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": "del 19 de junio al 12 de julio del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/PV_Arte + Educación_FB.jpg.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/14.-Convocatoria - Arte Educación.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
    },
   {
    "titulo": "del 02 de junio al 30 de junio del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Convocatoria Alumnos.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/11.-CONVOCATORIA ALUMNADO.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
    },
   {
    "titulo": "del 02 de junio al 11 de junio del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Convocatoria Talleristas.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/12.-CONVOCATORIA TALLERISTAS.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": "Resultados de la convocatoria Celeblando la Danza en los Centros Culturales Regionales",
    "imagen" : "../assets/imgs/Convocatorias/2026/Resultados de la convocatoria Celeblando la Danza en los CCRs.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/Resultados Danza en los CCRs.jpeg",
    "estado": "",
    "año": 2026
     },
    {
    "titulo": "Resultados de la convocatoria Encuentro Estatal de la Danza Contemporanea",
    "imagen" : "../assets/imgs/Convocatorias/2026/encuentro estatal.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/Resultados Encuentro estatal.jpeg",
    "estado": "",
    "año": 2026
     },
    {
    "titulo": "Resultados de la convocatoria Celebrando la Danza en Hidalgo",
    "imagen" : "../assets/imgs/Convocatorias/2026/Resultados Celebrando la Danza en Hidalgo.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/Resultados danza .jpeg",
    "estado": "",
    "año": 2026
     },
    {
    "titulo": "Resultados de la convocatoria Alas y Raíces 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Resultados AyR 2026.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/6.-Resultados AyR 2026, Hidalgo..pdf",
    "estado": "",
    "año": 2026
     },
    {
    "titulo": "del 25 de marzo al 17 de abril del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Celebrando la Danza en los Centros Culturales Regionales.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/10.-Celebrando la Danza en los CCRs.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": "del 25 de marzo al 10 de abril del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Celebrando la Danza en Hidalgo.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/9.-Convocatoria celebrando la danza .pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": "del 25 de marzo al 10 de abril del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Encuentro Estatal de Danza.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/8.-Encuentro Estatal de Danza Contemporanea .pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": " del 18 de marzo al 31 de marzo del 2026",
    "imagen" : "../assets/imgs/Convocatorias/2026/Alas y Raices 2026.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/7.-convocatoria Alas y Raices 2026.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     },
    {
    "titulo": "Resultados de la convocatoria del Dia Mundial del Teatro",
    "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/dmt.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/5.-Resultados Dia Mundial del Teatro.jpeg",
    "estado": "",
    "año": 2026
     },
    {
    "titulo": "del 24 de febrero al 07 de marzo",
    "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/dmt.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/6.-convocatoria DMT 2026.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     }, 
    {
    "titulo": "del 16 de febrero al 26 de febrero",
    "imagen" : "../assets/imgs/Convocatorias/2026/Maraton Nacional de Teatro.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/5.-Convocatoria 18 Gran Maratón Nacional de Teatro.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     }, 
    {
    "titulo": "Resultados del Taller de Teatro y Literatura",
    "imagen" : "../assets/imgs/Convocatorias/2026/Teatro y Literatura.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/1.-Resultados Teatro y Literatura.pdf",
    "estado": "",
    "año": 2026
     }, 
    {
    "titulo": "Resultados del Taller de Musica",
    "imagen" : "../assets/imgs/Convocatorias/2026/Musica.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/2.-Resultados Musica.pdf",
    "estado": "",
    "año": 2026
     }, 
    {
    "titulo": "Resultados del Taller de Danza",
    "imagen" : "../assets/imgs/Convocatorias/2026/Danza.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/3.-Resultados Danza.pdf",
    "estado": "",
    "año": 2026
     }, 
    {
    "titulo": "Resultados del Taller de Artes Visuales",
    "imagen" : "../assets/imgs/Convocatorias/2026/Artes Visuales.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados/4.-Resultados Visuales.pdf",
    "estado": "",
    "año": 2026
     }, 
    {
    "titulo": "del 03 de febrero al 28 de febrero",
    "imagen" : "../assets/imgs/Convocatorias/2026/Banda Sinfónica.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/4.Convocatoria banda.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     }, 
    {
    "titulo": "del 03 de febrero al 28 de febrero",
    "imagen" : "../assets/imgs/Convocatorias/2026/Coro.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/3.Convocatoria Coro Niñas y Niños Cantores de Hidalgo 2026.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
     }, 
    {
    "titulo": "del 03 de febrero al 28 de febrero",
    "imagen" : "../assets/imgs/Convocatorias/2026/Orquesta Sinfónica.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/2.Convocatoria orquesta.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
    }, 

    {
    "titulo": "del 19 de enero al 30 de enero",
    "imagen" : "../assets/imgs/Convocatorias/2026/Oferta academica 2026.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/1.-Convocatoria nuevo ingreso y oferta.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2026
    }, 

   {
    "titulo": "",
    "imagen" : "../assets/imgs/Convocatorias/2025/seleccionados PFAG-CAH.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/seleccionados PFAG-CAH.png",
    "estado": "Resultados",
    "año": 2025
    }, 

   {
    "titulo": "Del 24 de noviembre al 10 de diciembre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/taller aguafuerte CONVOCATORIA 3.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria  Taller Aguafuente.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025

    }, 
   {
    "titulo": "Del 13 de junio al 30 de noviembre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Convocatoria03.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria Programa de Apoyo para el Fortalecimiento de Actividades Artisticas y Culturales 2025.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },  
       {
    "titulo": "Del 13 de junio al 30 de noviembre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Convocatoria02.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria Programa para la Administración de Bienes, Servicios y Financiamiento a la Cultura del Ejercicio Fiscal 2025.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Del 01 de noviembre al 15 de noviembre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Curso Danza pequeño.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Danza CONVOCATORIA (1).pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    }, 
   {
    "titulo": "Del 31 de octubre al 15 de noviembre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Talleres.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },  
    {
    "titulo": "Del 27 de octubre al 11 de noviembre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Curso Danza.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Danza CONVOCATORIA.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    }, 
    {
    "titulo": "Del 17 de Septiembre al 02 de Octubre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/FESTIVAL PIANO.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/FESTIVAL DE PIANO CONVOCATORIA.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    }, 
      {
    "titulo": "Del 19 de Septiembre al 28 de Septiembre del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Banner.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Practicas Interdisciplinarias 2.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
   {
    "titulo": "Oferta Académica Musica para el Pueblo Apan, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo apan.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Centro Cultural del Ferrocarril, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo centro cultural del ferrocarril.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Centro de las Artes, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo centro de las artes.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Huejutla, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo huejutla.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Metztitlan, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo metztitlan.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Puebl Mineral del Chico, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo mineral del chico.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Mixquiahuala, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo mixquiahuala.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Progreso de Obregon, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo progreso de obregon.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo San Salvador, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo san salvador.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Santiago de Anaya, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/MP.png",
    "url" : "https://transparenciadocs.hidal/2025go.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo santiago de anaya.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Villa de Tezontepec, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo villa de tezontepec.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Zapotlan de Juárez, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo zapotlan de juarez.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Musica para el Pueblo Zempoala, Del 20 de Agosto al 25 de Agosto",
    "imagen" : "../assets/imgs/Convocatorias/2025/MP.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta musica para el pueblo zempola.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": " Oferta Académica Zimapán, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta zimapan.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria zimapan.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": " Oferta Académica Zacualtipán, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta zacualtipan.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria zacualtipan.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": " Oferta Académica Valle del Mezquital, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta valle.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria valle del mezquital.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": " Oferta Académica Tlahuelilpan, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta tlahuelilpan 1.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria tlahuelilpan.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": " Oferta Académica Tepeapulco, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta tepeapulco 1.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria tepeapulco.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": " Oferta Académica Real del Monte, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta real del monte 1.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria real del monte.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Sierra Otomí Tepehua, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta otomi tepehua 1.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria sierra otomi tepehua.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": " Oferta Académica Huichapan, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta huichapan 1.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria huichapan.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica de la Huasteca, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta huasteca 1.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria huasteca.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Oferta Académica Emiliano Zapata, Del 12 de Agosto al 22 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/convocatoria abierta emiliano zapata 1.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/convocatoria emiliano zapata.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
   {
    "titulo": "Del 01 de Agosto al 11 de Agosto del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/CAH.jpeg",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/oferta academica.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
    {
    "titulo": "Del 09 de julio al 18 de julio del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Convocatoria04.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria Musicampus .png",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },
     {
    "titulo": "Del 26 de mayo al 06 de junio del 2025",
    "imagen" : "../assets/imgs/Convocatorias/2025/Convocatoria01.png",
    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria%20Programa%20de%20Desarrollo%20Cultural%20Infantil.pdf",
    "estado": "CONVOCATORIA CERRADA",
    "año": 2025
    },  
     
]